import React, { useMemo } from 'react';

import Iwoca from '../../svgs/logo/iwoca.svg';
import IwocaPay from '../../svgs/logo/iwocaPay.svg';
import IwocaPayText from '../../svgs/logo/iwocaPayText.svg';
import IwocaText from '../../svgs/logo/iwocaText.svg';

export type IwocaLogoProps = {
  color?: 'red' | 'white' | 'black';
  iconOnly?: boolean;
  iwocaPay?: boolean;
} & React.SVGAttributes<SVGElement>;

export const IwocaLogo = ({
  color = 'red',
  iconOnly,
  iwocaPay,
  className,
}: IwocaLogoProps) => {
  const fill = useMemo(() => {
    switch (color) {
      case 'red':
        return '#fb5950';
      case 'white':
        return '#fff';
      case 'black':
        return '#000';
    }
  }, [color]);

  if (iwocaPay) {
    return iconOnly ? (
      <IwocaPay className={className} fill={fill} height="auto" width="auto" />
    ) : (
      <IwocaPayText
        className={className}
        fill={fill}
        height="auto"
        width="auto"
      />
    );
  } else {
    return iconOnly ? (
      <Iwoca className={className} fill={fill} height="auto" width="auto" />
    ) : (
      <IwocaText className={className} fill={fill} height="auto" width="auto" />
    );
  }
};
